export enum SeenUserStatus {
	NOBODY = 1,
	FRIENDS = 2,
	EVERYONE = 3
}

export namespace SeenUserStatus {

	export function getTitle(type: SeenUserStatus): string {
		return Object.keys(SeenUserStatus).find(key => SeenUserStatus[key] === type);
	}

}

